import React, {Component} from 'react'
import LayoutDashboard from "../../components/layout-dashboard";
import {connect} from "react-redux";
import {CloudIcon, CogIcon} from "@heroicons/react/solid";
import AccountTab from "./accountTab";
import ProfileTab from "./profileTab";
import {checkPerm, READ_PERM} from "../../util/util";
import Resources from "../../data/services/resources";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

class SettingsPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            subNavigation: checkPerm(Resources.Company, READ_PERM) ? [
                {
                    name: 'Account',
                    description: 'Edit account settings, like name or timezone',
                    href: '#',
                    icon: CloudIcon
                },
                {
                    name: 'Profile',
                    description: 'Edit basic profile settings, like name or timezone',
                    href: '#',
                    icon: CogIcon
                }
            ] : [
                {
                    name: 'Profile',
                    description: 'Edit basic profile settings, like name or timezone',
                    href: '#',
                    icon: CogIcon
                }
            ],
            selectedTab: checkPerm(Resources.Company, READ_PERM) ? 'Account' : 'Profile'
        };
    }

    /** Lifecycle
     ================================================================= */


    /** Render
     ================================================================= */
    render() {

        return (
            <LayoutDashboard noDefaultLayout {...this.props}>
                <main className="flex flex-col md:flex-row custom-min-h-page-2">
                    {/* Secondary sidebar */}
                    <nav
                        aria-label="Sections"
                        className="flex-shrink-0 md:w-96 bg-white border-r border-primary-gray-200 xl:flex xl:flex-col"
                    >
                        <div className="flex-shrink-0 h-16 px-6 border-b border-primary-gray-200 flex items-center">
                            <p className="text-lg font-medium text-primary-gray-900">Settings</p>
                        </div>
                        <div className="flex-1 min-h-0 overflow-y-auto">
                            {this.state.subNavigation.map((item, i) => (
                                <a
                                    key={item.name}
                                    href={item.href}
                                    className={classNames(
                                        (this.state.selectedTab === item.name) ? 'bg-secondary-50 bg-opacity-50' : 'hover:bg-secondary-50 hover:bg-opacity-50',
                                        'flex p-6 border-b border-gray-200'
                                    )}
                                    aria-current={(this.state.selectedTab === item.name) ? 'page' : undefined}
                                    onClick={() => {
                                        this.setState({
                                            selectedTab: item.name
                                        })
                                    }}
                                >
                                    <item.icon className="flex-shrink-0 -mt-0.5 h-6 w-6 text-gray-400"
                                               aria-hidden="true"/>
                                    <div className="ml-3 text-sm">
                                        <p className="font-medium text-gray-900">{item.name}</p>
                                        <p className="mt-1 text-gray-500">{item.description}</p>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </nav>

                    <div className="flex-1 sm:overflow-y-auto h-[calc(100vh-4rem)] bg-gray-50">
                        <div className="mx-auto py-10 px-6 lg:py-12 lg:px-12">
                            {(this.state.selectedTab === ('Account')) && (
                                <AccountTab
                                    dispatch={this.props.dispatch}
                                    translate={this.props.translate}
                                    resource={this.props.resource}
                                />
                            )}


                            {(this.state.selectedTab === ('Profile')) && (
                                <ProfileTab
                                    dispatch={this.props.dispatch}
                                    translate={this.props.translate}
                                    resource={this.props.resource}
                                />
                            )}
                        </div>
                    </div>
                </main>
            </LayoutDashboard>
        )
    }
}

export default connect(state => state)(SettingsPage);